import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cbs_overview = _resolveComponent("cbs-overview")!

  return (_openBlock(), _createBlock(_component_cbs_overview, {
    onCopyContentBlock: ($event: any) => (null/*copyContentBlock*/),
    onCopiedLibCb: _ctx.reloadContent,
    onDeleteContentBlock: _ctx.deleteContentBlock,
    "content-blocks": _ctx.contentBlocks,
    "content-type": _ctx.isBannerInSlot ? 'BANNER_IN_SLOT' : 'BANNER',
    "cb-type": _ctx.cbType,
    "can-copy-item": _ctx.canCopyItem,
    "can-use-library": _ctx.canUseLibrary,
    "is-ready": _ctx.isReady,
    "has-content-blocks": _ctx.hasContentBlocks,
    description: _ctx.description,
    title: _ctx.title,
    "route-object-edit-cb": _ctx.routeObjectEditCb,
    "route-object-new-cb": _ctx.routeObjectNewCb,
    "table-header-items": _ctx.tableHeaderItems
  }, null, 8, ["onCopiedLibCb", "onDeleteContentBlock", "content-blocks", "content-type", "cb-type", "can-copy-item", "can-use-library", "is-ready", "has-content-blocks", "description", "title", "route-object-edit-cb", "route-object-new-cb", "table-header-items"]))
}